"use strict";

exports.__esModule = true;
exports.ClassificationButtonGroup = ClassificationButtonGroup;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Heading = require("../../Core/Heading");
var _excluded = ["label", "children", "state"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var ClassificationButtonGroupInner = _styledComponents["default"].div.withConfig({
  displayName: "ClassificationButtonGrouplegacy__ClassificationButtonGroupInner",
  componentId: "sc-1n3w7gh-0"
})(["margin-top:1rem;margin-bottom:1rem;display:grid;grid-template-columns:repeat(auto-fill,minmax(140px,1fr));grid-column-gap:1rem;grid-row-gap:1rem;"]);
function ClassificationButtonGroup(props) {
  // `state` is for the modern group's header; it must not reach the DOM.
  // eslint-disable-next-line no-unused-vars
  var label = props.label,
    children = props.children,
    state = props.state,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement("section", extra, label && /*#__PURE__*/_react["default"].createElement(_Heading.Heading, {
    level: "3"
  }, label), /*#__PURE__*/_react["default"].createElement(ClassificationButtonGroupInner, null, children));
}